export const GET_ALL_CITIES = `
query Cities {
  cities {
    id
    name
    showBookNow
  }
}
`;

export const GET_AREAS_BY_CITY = `
query GetAreasByCity($cityId: ID!) {
  areasByCity(cityId: $cityId) {
    id
    name
    cityId
  }
}
`;


export const GET_TURFS_BY_USERNAME = `
query GetData($username:String!,$input:CreateTurfInput) {
    turfByUsername(username:$username,input:$input) {
      verificationStatus
      deletedTurf
      hideTurf
      name
      id
      username
      supportNumber
      turfEmail
      coverImage
      logo
      city
      areaName
      areaId
      images
      logo
      floor
      latitude
      longitude
      address
      googleRating
      googleRatingUserCount
      turfBookingRating
      turfBookingRatingCount
      hasCafe
      isCovered
      hasParking
      airConditioning
      providesEquipment
      opens24x7
      isPartner
      supportedSports
      isIndoor
      isRainProtected
      sportImages
      allowCustomerPayAndBook
      Pitch{
      id
      hidePitch
      sport
      supportedSports
      pitchName
      basePrice
      area
      playingFormat
      length
      width
      height
      surface
      courtType
      dailyPricings{
      startTime
      endTime
      price
      dayOfTheWeek
      }
    }
      turfAddress{
        id
        turfId
        cityId
        streetName
        landmark
        pincode
      }
      workingHours {
        sport
        dayOfTheWeek
        openingTime
        closingTime
      }
     }
  }
`;


export const GET_ALL_TURFS = `
query turfList ($city:String,$username:String,$verificationStatus:String,$limit: Int, $offset: Int){
  turfs (city:$city, username:$username, verificationStatus:$verificationStatus, limit:$limit, offset:$offset){
    turfs {
      id
      verificationStatus
      name
      username
      supportNumber
      turfEmail
      coverImage
      logo
      images
      city
      areaName
      areaId
      latitude
      longitude
      address
      googleRating
      googleRatingUserCount
      turfBookingRating
      turfBookingRatingCount
      hasCafe
      isCovered
      hasParking
      airConditioning
      providesEquipment
      opens24x7
      isPartner
      supportedSports
      isIndoor
      isRainProtected
      sportImages
      deletedTurf
      hideTurf
       Pitch {
      area
      playingFormat
      basePrice
      id
      hidePitch
      sport
      supportedSports
      pitchName
      surface
      courtType
    }
      turfAddress{
        id
        turfId
        streetName
        landmark
        pincode
      }
      workingHours {
        sport
        dayOfTheWeek
        openingTime
        closingTime
      }
    }
    totalCount
  }
}
`;

export const GET_TURFS_FOR_SITEMAP = `
query turfList($city: String, $verificationStatus: String) {
  turfs(city: $city, verificationStatus: $verificationStatus) {
    turfs {
      name
      username
      city
      areaName
      deletedTurf
      hideTurf
      Pitch {
        area
        playingFormat
        id
        hidePitch
        pitchName
      }
    }
    totalCount
  }
}
`;

export const SUPPORTED_CITIES_SHOW_TURF_DB = ['Bhopal','Betma'];